import { useTranslation } from 'next-i18next';
import React from 'react';

import { useCountryCode } from '../../../../hooks/useCountryCode';
import {
  GeneratedCalculateOrderPricingQuery,
  GeneratedTaxType,
} from '../../../../types/generated';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import ReviewSummary from './ReviewSummary';

interface PriceBreakdownProps<T extends ProductPurchaseDetails> {
  purchasing: ProductPurchasingController<T>;
  orderPriceCalculation?: GeneratedCalculateOrderPricingQuery['calculateOrderPricing'];
  loading: boolean;
}

const PriceBreakdown: React.FC<PriceBreakdownProps<ProductPurchaseDetails>> = ({
  loading,
  orderPriceCalculation,
  purchasing,
}) => {
  const { t } = useTranslation('product');
  const { t: tCountries } = useTranslation('countries');
  const { product } = purchasing;

  const [countryCode] = useCountryCode();
  const country = tCountries(countryCode) ?? 'your country';

  if (!purchasing.product) return null;

  return (
    <div>
      <ReviewSummary
        loading={loading}
        orderPriceCalculation={orderPriceCalculation}
        product={product || undefined}
      />

      {!!orderPriceCalculation?.taxRate &&
        orderPriceCalculation.taxType === GeneratedTaxType.Ddp && (
          <div className="mt-9">
            <div className="font-bold">
              {t('drawers.fees.dutyTaxExplainer.title')}
            </div>
            <div>{t('drawers.fees.dutyTaxExplainer.body', { country })}</div>
          </div>
        )}
    </div>
  );
};

export default PriceBreakdown;
